import { isNil } from 'lodash';
import { usePrescriptionsInCart } from '~shared/features/cart/hooks/usePrescriptionsInCart';
import { NO_SHARPS_CONTAINER_SELECTED } from '~shared/features/checkout/constants';
import { getOrderIncludeSharpsContainer } from '~shared/features/checkout/selectors/getOrder';
import { type ValidationError } from '~shared/features/checkout/types';
import { useSelectorShared } from '~shared/store';

export const useCheckoutSharpsContainerErrors = () => {
  const includesSharpsContainer = useSelectorShared(getOrderIncludeSharpsContainer);
  const { hasInjectables, hasOnlyInjectableCompounds } = usePrescriptionsInCart();

  const errors: ValidationError[] = [];

  if (hasInjectables && !hasOnlyInjectableCompounds && isNil(includesSharpsContainer)) {
    errors.push({
      key: NO_SHARPS_CONTAINER_SELECTED,
      message: 'Please select whether you would like a sharps container.',
    });
  }

  return { sharpsContainerValidationErrors: errors };
};
